import { RuleTrigger } from './rule.i';
import { RuleConditionBuilder } from './rule-condition.builder';
import { RuleActionBuilder } from './rule-action.builder';
var RuleBuilder = /** @class */ (function () {
    function RuleBuilder() {
        this.rule = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'Bob Saget',
            description: 'This is description',
            disabled: false,
            triggers: [RuleTrigger.TICKET_CREATED],
            mustConditions: [new RuleConditionBuilder().build()],
            shouldConditions: [new RuleConditionBuilder().build()],
            actions: [new RuleActionBuilder().build()],
        };
    }
    RuleBuilder.prototype.withId = function (id) {
        this.rule.id = id;
        return this;
    };
    RuleBuilder.prototype.withName = function (name) {
        this.rule.name = name;
        return this;
    };
    RuleBuilder.prototype.withDescription = function (description) {
        this.rule.description = description;
        return this;
    };
    RuleBuilder.prototype.withDisabled = function (disabled) {
        this.rule.disabled = disabled;
        return this;
    };
    RuleBuilder.prototype.withTriggers = function (triggers) {
        this.rule.triggers = triggers;
        return this;
    };
    RuleBuilder.prototype.withMustConditions = function (mustConditions) {
        this.rule.mustConditions = mustConditions;
        return this;
    };
    RuleBuilder.prototype.withShouldConditions = function (shouldConditions) {
        this.rule.shouldConditions = shouldConditions;
        return this;
    };
    RuleBuilder.prototype.withActions = function (actions) {
        this.rule.actions = actions;
        return this;
    };
    RuleBuilder.prototype.build = function () {
        return this.rule;
    };
    return RuleBuilder;
}());
export { RuleBuilder };
//# sourceMappingURL=rule.builder.js.map